export const EXAMPLE_PATH = "cms-ghost";
export const CMS_NAME = "Ghost";
export const CMS_URL = "https://ghost.org/";
export const HOME_OG_IMAGE_URL =
  "https://og-image.vercel.app/Next.js%20Example%20Blog%20with%20**Ghost**.png?theme=light&md=1&fontSize=75px&images=https%3A%2F%2Fassets.vercel.com%2Fimage%2Fupload%2Ffront%2Fassets%2Fdesign%2Fnextjs-black-logo.svg&images=https%3A%2F%2Fghost.org%2Fimages%2Flogo.svg";
